import { TaskTypeDefinition } from '@modules/TasksModule/types';
import { ManualBookingCard } from '@pages/agent/InboxPage/components/ManualBookingCard';
import ManualBookingTaskView from '@pages/agent/InboxPage/components/ManualBookingTaskView';
import { MANUAL_BOOKING_TASK_TYPE } from '../lib/manualBookings';

const manualBookingTaskType: TaskTypeDefinition = {
  key: MANUAL_BOOKING_TASK_TYPE,
  category: 'Manual bookings',
  types: [MANUAL_BOOKING_TASK_TYPE],
  taskRowComponent: ManualBookingCard,
  taskViewComponent: ManualBookingTaskView,
  // Manual booking cards live in memory only: a refresh clears them.
  handleHydration: () => null,
};

export default manualBookingTaskType;
